<template>
  <section id="faqs-panel" class="py-10">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <h2 class="font-display text-4xl font-bold tracking-tighter text-gray-900 sm:text-5xl">
        Frequently Asked Questions
      </h2>
      <dl class="mt-4 space-y-6 divide-y divide-gray-900/10">
        <Disclosure as="div" v-for="faq in faqs" :key="faq.question" class="pt-6" v-slot="{ open }">
          <dt>
            <DisclosureButton class="flex w-full items-start justify-between text-left text-gray-900">
              <span class="text-base font-semibold">{{ faq.question }}</span>
              <span class="ml-6 flex items-center">
                <PlusSmallIcon v-if="!open" class="h-6 w-6" aria-hidden="true" />
                <MinusSmallIcon v-else class="h-6 w-6" aria-hidden="true" />
              </span>
            </DisclosureButton>
          </dt>
          <DisclosurePanel as="dd" class="mt-2 pr-12">
            <p class="text-base leading-7 text-gray-600" v-html="faq.answer"></p>
          </DisclosurePanel>
        </Disclosure>
      </dl>
    </div>
  </section>
</template>

<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/vue/24/outline'

const faqs = [
  {
    question: 'How can I financially support this event?',
    answer: 'Prayer Storm is a non profit organisation and aims to make tickets free or as affordable as possible. If you would like to support this event and help make it possible via financial support, you can do so here: <a href="https://donate.stripe.com/3cIaEY899evN1Zzg3adQQ0c" target="_blank" rel="noopener noreferrer" class="text-blue underline font-bold">Battle For Britain Support</a>.'
  },
  {
    question: 'Where can I order tickets?',
    answer: 'You can order tickets via this page above. Please find the button \'Order Your Tickets Now\'. PLEASE NOTE: Only people with a valid QR code tickets and a delegate name upon the ticket will be permitted entrance to attend, this includes children.'
  },
  {
    question: 'Where and when is this taking place?',
    answer: 'Manchester Central, Petersfield, M2 3GX, UK. Taking place on 20-22 August 2026.'
  },
  {
    question: 'Can I bring my children?',
    answer: 'Due to the size and security of Manchester Central, all people attending the Prayer Storm Conference 2026 will require a named ticket to gain entrance into both the Main Venue and the Kids Venue. Children and Youth 7-16 years of age will be able to attend the Kids Venue taking place at the same the time as the Main Venue. PLEASE NOTE: The Kids Venue is only for 7-16 year olds due to safeguarding and event safety. Children aged 0-6 years will need to remain with their parent/guardian in the Main Venue at all times.'
  },
  // {
  //   html: true,
  //   question: 'What hotels are nearby?',
  //   answer: 'Marketing Manchester Convention Bureau is the official accommodation provider for Prayer Storm 2025 Annual Conference. Please see the section titled \'Accomodation in Manchester\' above.'
  // },
  {
    question: 'Can I bring luggage?',
    answer: 'You are not allowed to bring large luggage or bags into the venue. Please only bring small bags that you can carry with you. There will be no storage facilities available for luggage or large bags.'
  },
  {
    html: true,
    question: 'How do I get to Manchester Central?',
    answer: 'We\'ve provided some details above that may help with getting to Manchester Central. Please see the section titled \'Getting to Manchester Central\' above.'
  },
  {
    question: 'Can you provide a letter for my visa?',
    answer: 'Unfortunately we are unable to provide letters or documentation for visa applications.'
  },
  {
    question: 'Can you provide information for my travel arrangements?',
    answer: 'We cannot provide travel arrangements for individuals attending.'
  },
  {
    question: 'Can I get a refund?',
    answer: 'Please refer to our <a href="https://docs.prayerstorm.org/reference/events/tickets/cancellations-and-refunds" target="_blank" rel="noopener noreferrer" class="text-blue underline font-bold">Cancellations and Refunds Policy</a>.'
  }
]
</script>
